// extracted by mini-css-extract-plugin
export var defaultStyles = "index-module--defaultStyles--b3wgi";